import { Controls } from 'modules/Insights/Controls'
import { useMemo, useState } from 'react'
import { EventTypesWidget } from 'modules/Insights/widgets/EventTypesWidget/EventTypesWidget'
import { InvoicedRevenueWidget } from 'modules/Insights/widgets/InvoicedRevenueWidget/InvoicedRevenueWidget'
import OutstandingInvoices from 'modules/Insights/widgets/OutstandingInvoices/OutstandingInvoices'
import TotalCustomersWidget from 'modules/Insights/widgets/TotalCustomersWidget/TotalCustomersWidget'
import { UsageMetricsWidget } from 'modules/Insights/widgets/UsageMetricsWidget/UsageMetricsWidget'
import { lastDayOfMonth, startOfMonth, sub } from '@sequencehq/utils/dates'
import { PageTitle, Panel, Box, Flex } from '@sequencehq/core-components'

const NOW = new Date()

const DATE_RANGE_PRESETS = {
  this_month: [new Date(startOfMonth(NOW)), new Date(lastDayOfMonth(NOW))],
  '3_months': [new Date(startOfMonth(sub(NOW, { months: 2 }))), NOW],
  '6_months': [new Date(startOfMonth(sub(NOW, { months: 5 }))), NOW],
  last_year: [new Date(startOfMonth(sub(NOW, { months: 12 }))), NOW]
}

export const Insights = () => {
  const [preset, setPreset] = useState('this_month')

  const dateRange = useMemo(
    () => ({
      start: DATE_RANGE_PRESETS[preset as keyof typeof DATE_RANGE_PRESETS][0],
      end: DATE_RANGE_PRESETS[preset as keyof typeof DATE_RANGE_PRESETS][1]
    }),
    [preset]
  )

  return (
    <>
      <PageTitle title={['Insights']} />
      <Panel
        display="flex"
        flexDirection="column"
        width="100%"
        height="100%"
        minHeight="0"
      >
        <Box flexShrink={0}>
          <Controls
            preset={preset}
            onChangePreset={(newPreset: string) => {
              setPreset(newPreset)
            }}
          />
        </Box>
        <Box width="100%" flex="1" minHeight="0" overflowY="auto">
          <Flex
            width="100%"
            flexWrap="wrap"
            gap={4}
            padding={4}
            transform="translateX(8px)"
          >
            <TotalCustomersWidget />
            <InvoicedRevenueWidget dateRange={dateRange} />
            <OutstandingInvoices />
            <EventTypesWidget dateRange={dateRange} />
            <UsageMetricsWidget dateRange={dateRange} />
          </Flex>
        </Box>
      </Panel>
    </>
  )
}
